module.exports = __webpack_public_path__ + "img/28-2.e102bcc8.jpg";